import React ,{useEffect} from 'react';
import { Link } from 'react-router-dom';
import './BoothInfo2.css';
import jujeom from './jujeom/Jujeom_final.png';
import backbtn from './booth_back_button.png';




const MIN_SPEED = 1.0;
const MAX_SPEED = 2.0;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}

const JujeomBooth = () => {

  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();
  }, []);

  return (
    <div className='page2'>
 

      <img src={jujeom} alt='' useMap='#jujeomMap' />

      <Link to='/booth-info'>
        <img src={backbtn} alt='' />
      </Link>

      <map name='jujeomMap'>
        <area target='_blank' alt='철학' title='철학' href='https://www.instagram.com/cuk_philosophy/' coords='52,128,88,160' shape='rect' />
        <area target='_blank' alt='프문' title='프문' href='https://www.instagram.com/cuk_fr/' coords='54,166,87,198' shape='rect' />
        <area target='_blank' alt='일문' title='일문' href='https://www.instagram.com/cuk_japan/' coords='53,207,87,239' shape='rect' />
        <area target='_blank' alt='중문' title='중문' href='https://www.instagram.com/cuk_chinese/' coords='53,246,86,277' shape='rect' />
        <area target='_blank' alt='영문' title='영문' href='https://www.instagram.com/cuk_english/' coords='53,290,87,318' shape='rect' />
        <area target='_blank' alt='국제' title='국제' href='https://www.instagram.com/cuk_sis/' coords='53,325,88,355' shape='rect' />
        <area target='_blank' alt='소피바라' title='소피바라' href='https://www.instagram.com/sophiebarat_cuk/' coords='55,366,86,397' shape='rect' />
        <area target='_blank' alt='사회' title='사회' href='https://www.instagram.com/cuk_socio/' coords='55,408,86,437' shape='rect' />
        <area target='_blank' alt='태권도부' title='태권도부' href='https://www.instagram.com/cuk_taekwondo/' coords='54,449,86,477' shape='rect' />
        <area target='_blank' alt='바스타즈' title='바스타즈' href='https://www.instagram.com/cuk_bastards/' coords='54,487,86,517' shape='rect' />
        <area target='_blank' alt='에환공' title='에환공' href='https://www.instagram.com/cuk_energy_envtech/' coords='55,526,85,556' shape='rect' />
        <area target='_blank' alt='법학' title='법학' href='https://www.instagram.com/cuk_law_/' coords='54,570,86,598' shape='rect' />
        <area target='_blank' alt='행정' title='행정' href='https://www.instagram.com/cuk_pa_29/' coords='327,136,359,166' shape='rect' />
        <area target='_blank' alt='의생명' title='의생명' href='https://www.instagram.com/cuk_med_bioscience/' coords='326,224,356,254' shape='rect' />
        <area target='_blank' alt='국사' title='국사' href='https://www.instagram.com/cuk_history/' coords='326,266,356,294' shape='rect' />
        <area target='_blank' alt='국문' title='국문' href='https://www.instagram.com/cuk_kll/' coords='327,309,357,336' shape='rect' />
        <area target='_blank' alt='경영' title='경영' href='https://www.instagram.com/cuk_business20/' coords='328,350,354,376' shape='rect' />
        <Link to = '/menu1'>
        <area target='_blank' alt='더게임' title='더게임' coords='328,390,355,418' shape='rect' />
        </Link>
        <area target='_blank' alt='정통' title='정통' href='https://www.instagram.com/cuk.ice/' coords='327,436,354,461' shape='rect' />
        <area target='_blank' alt='컴공' title='컴공' href='https://www.instagram.com/cuk.csie/' coords='327,476,357,505' shape='rect' />
        <area target='_blank' alt='미콘' title='미콘' href='https://www.instagram.com/cuk_mtc/' coords='329,517,357,546' shape='rect' />
        <area target='_blank' alt='바메화공' title='바메화공' href='https://www.instagram.com/cuk_bmce/' coords='326,560,356,587' shape='rect' />
        <area target='_blank' alt='이과대' title='이과대' href='https://www.instagram.com/cuk_ns/' coords='328,603,356,628' shape='rect' />
        <area target='_blank' alt='총학' title='총학' href='https://www.instagram.com/cuk_student/' coords='181,603,217,635' shape='rect' />
      </map>

      <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>




    </div>
  );
};

export default JujeomBooth;
